module.exports = __webpack_public_path__ + "static/media/gdpr-for-marketing-cover-en.9b8635d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ebook/gdpr-for-marketing-cover-en.png
// module id = 555
// module chunks = 0